<div class="dashboard-style-modal modal-box" cdkDrag>
    <div class="modal-header dashboard-style-modal__header" cdkDragHandle>
        <div class="dashboard-style-modal__headline modal-headline">
            <span class="dashboard-style-modal__eyebrow modal-eyebrow">{{ 'DISPLAY_SETTINGS' | translate }}</span>
            <h4 class="modal-title dashboard-style-modal__title modal-heading">{{ 'DASHBOARD_SETTINGS' | translate }}</h4>
            <!-- <p>Manage the saved dashboard appearance for your browser. Tasks and DMS dashboards are stored separately.</p> -->
        </div>
        <button type="button" class="dashboard-style-modal__close modal-close" [attr.aria-label]="'CLOSE' | translate" (click)="activeModal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body dashboard-style-modal__body">
        <div class="dashboard-style-modal__tabs" role="tablist" [attr.aria-label]="'DASHBOARD_STYLE_TABS' | translate">
            <button
                type="button"
                class="dashboard-style-modal__tab"
                [class.dashboard-style-modal__tab--active]="activeTab === 'tasks'"
                [attr.aria-selected]="activeTab === 'tasks'"
                (click)="activeTab = 'tasks'">
                {{ 'TASKS_DASHBOARD' | translate }}
            </button>
            <button
                type="button"
                class="dashboard-style-modal__tab"
                [class.dashboard-style-modal__tab--active]="activeTab === 'dms'"
                [attr.aria-selected]="activeTab === 'dms'"
                (click)="activeTab = 'dms'">
                {{ 'DMS_DASHBOARD' | translate }}
            </button>
            <button
                type="button"
                class="dashboard-style-modal__tab"
                [class.dashboard-style-modal__tab--active]="activeTab === 'ai'"
                [attr.aria-selected]="activeTab === 'ai'"
                (click)="activeTab = 'ai'">
                {{ 'AI_SETTINGS' | translate }}
            </button>
        </div>

        <div *ngIf="activeTab !== 'ai'" class="dashboard-style-modal__panel">
            <div class="row mb-3 dashboard-style-modal__setting-row">
                <label class="col-sm-4 col-form-label">{{ 'BACKGROUND_IMAGE' | translate }}</label>
                <div class="col-sm-8 dashboard-style-modal__control">
                    <input
                        #bgFileInput
                        type="file"
                        accept="image/*"
                        hidden
                        (change)="onBackgroundFileSelected($event); bgFileInput.value = ''">
                    <div class="dashboard-style-modal__actions">
                        <button type="button" class="gray-button dashboard-style-modal__button" (click)="bgFileInput.click()">{{ 'UPLOAD_REPLACE' | translate }}</button>
                        <button type="button" class="red-outline-button dashboard-style-modal__button dashboard-style-modal__button--secondary" (click)="removeBackgroundImage()">{{ 'REMOVE' | translate }}</button>
                    </div>
                </div>
            </div>

            <div class="row mb-3 dashboard-style-modal__setting-row">
                <label class="col-sm-4 col-form-label">{{ 'BACKGROUND_OPACITY' | translate }}</label>
                <div class="col-sm-8 dashboard-style-modal__control">
                    <input
                        type="range"
                        min="0"
                        max="100"
                        step="5"
                        class="form-range"
                        [ngModel]="activeState.bgImageOpacityPct"
                        (ngModelChange)="updateActiveSettings({ bgImageOpacityPct: $event })">
                    <div class="text-muted dashboard-style-modal__value">{{ activeState.bgImageOpacityPct }}%</div>
                </div>
            </div>

            <hr />
<!--
            <div class="row mb-3 dashboard-style-modal__setting-row">
                <label class="col-sm-4 col-form-label">{{ 'CARD_BACKGROUND_COLOR' | translate }}</label>
                <div class="col-sm-8 dashboard-style-modal__control">
                    <input
                        type="color"
                        [ngModel]="activeState.cardBgColor"
                        (ngModelChange)="updateActiveSettings({ cardBgColor: $event })" />
                </div>
            </div>

            <div class="row mb-3 dashboard-style-modal__setting-row">
                <label class="col-sm-4 col-form-label">{{ 'CARD_BACKGROUND_OPACITY' | translate }}</label>
                <div class="col-sm-8 dashboard-style-modal__control">
                    <input
                        type="range"
                        min="0"
                        max="100"
                        step="5"
                        class="form-range"
                        [ngModel]="activeState.cardBgOpacityPct"
                        (ngModelChange)="updateActiveSettings({ cardBgOpacityPct: $event })">
                    <div class="text-muted dashboard-style-modal__value">{{ activeState.cardBgOpacityPct }}%</div>
                </div>
            </div>

            <hr />
-->
            <div class="row mb-3 dashboard-style-modal__setting-row">
                <label class="col-sm-4 col-form-label">{{ 'TASK_COLUMNS_BACKGROUND_COLOR' | translate }}</label>
                <div class="col-sm-8 dashboard-style-modal__control">
                    <input
                        type="color"
                        [ngModel]="activeState.taskcolBgColor"
                        (ngModelChange)="updateActiveSettings({ taskcolBgColor: $event })" />
                </div>
            </div>

            <div class="row mb-3 dashboard-style-modal__setting-row">
                <label class="col-sm-4 col-form-label">{{ 'TASK_COLUMNS_BACKGROUND_OPACITY' | translate }}</label>
                <div class="col-sm-8 dashboard-style-modal__control">
                    <input
                        type="range"
                        min="0"
                        max="100"
                        step="5"
                        class="form-range"
                        [ngModel]="activeState.taskcolBgOpacityPct"
                        (ngModelChange)="updateActiveSettings({ taskcolBgOpacityPct: $event })">
                    <div class="text-muted dashboard-style-modal__value">{{ activeState.taskcolBgOpacityPct }}%</div>
                </div>
            </div>

            <hr />

            <div class="row mb-0 dashboard-style-modal__setting-row">
                <label class="col-sm-4 col-form-label">{{ 'TASK_HEADER_COLOR' | translate }}</label>
                <div class="col-sm-8 dashboard-style-modal__control">
                    <input
                        type="color"
                        [ngModel]="activeState.taskHeaderColor"
                        (ngModelChange)="updateActiveSettings({ taskHeaderColor: $event })" />
                </div>
            </div>
        </div>

        <div *ngIf="activeTab === 'ai'" class="dashboard-style-modal__panel">
            <div class="row mb-3 dashboard-style-modal__setting-row">
                <label class="col-sm-4 col-form-label" for="preferredAiModel">{{ 'PREFERRED_AI_MODEL' | translate }}</label>
                <div class="col-sm-8 dashboard-style-modal__control">
                    <ng-select
                        id="preferredAiModel"
                        [items]="['gpt-5-mini', 'gpt-5', 'gpt-5.6-luna', 'gpt-5.6-terra']"
                        [clearable]="false"
                        [ngModel]="aiRewriteModel"
                        (ngModelChange)="updateAiRewriteModel($event)">
                    </ng-select>
                </div>
            </div>

            <div class="row mb-3 dashboard-style-modal__setting-row">
                <label class="col-sm-4 col-form-label" for="aiRewritePromptPrefix">{{ 'AI_REWRITE_INSTRUCTIONS' | translate }}</label>
                <div class="col-sm-8 dashboard-style-modal__control">
                    <textarea
                        id="aiRewritePromptPrefix"
                        class="form-control"
                        rows="5"
                        [ngModel]="aiRewritePromptPrefix"
                        (ngModelChange)="updateActiveSettings({ aiRewritePromptPrefix: $event })">
                    </textarea>
                </div>
            </div>

            <div class="row mb-3 dashboard-style-modal__setting-row">
                <label class="col-sm-4 col-form-label" for="aiRewriteSystemContent">{{ 'AI_REWRITE_SYSTEM_CONTENT' | translate }}</label>
                <div class="col-sm-8 dashboard-style-modal__control">
                    <textarea
                        id="aiRewriteSystemContent"
                        class="form-control"
                        rows="4"
                        [ngModel]="aiRewriteSystemContent"
                        (ngModelChange)="updateActiveSettings({ aiRewriteSystemContent: $event })">
                    </textarea>
                </div>
            </div>

            <div class="row mb-0 dashboard-style-modal__setting-row">
                <label class="col-sm-4 col-form-label" for="aiRewriteTemperature">{{ 'AI_REWRITE_TEMPERATURE' | translate }}</label>
                <div class="col-sm-8 dashboard-style-modal__control">
                    <input
                        id="aiRewriteTemperature"
                        class="form-control"
                        type="number"
                        min="0"
                        max="1.4"
                        step="0.1"
                        [ngModel]="aiRewriteTemperature"
                        (ngModelChange)="updateAiRewriteTemperature($event)" />
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer dashboard-style-modal__footer" cdkDragHandle>
        <div class="dashboard-style-modal__actions modal-actions">
            <button type="button" class="red-outline-button dashboard-style-modal__button dashboard-style-modal__button--secondary" (click)="resetStyleSettingsToDefault()">{{ 'RESET_CURRENT_TAB' | translate }}</button>
            <button type="button" class="gray-button dashboard-style-modal__button" (click)="activeModal.close()">{{ 'CLOSE' | translate }}</button>
        </div>
    </div>
</div>
